// internal state code for navigation menu
// call init() to add events to open menu and close menu buttons
enum NavMenuAction {
  toggleMenu = "toggleNavMenu",
  itemClicked = "itemClicked",
}

let CTAButtonEl: HTMLElement;
interface INavMenuItem {
  screenId: string;
  label: string;
}

interface INavMenuCallback {
  ACTION: NavMenuAction;
  state: any;
}

let isMenuOpen: boolean = false;
let callback: Function;
let gCurrentSelected: HTMLElement | null;

const addMenuButtonEvents = () => {
  document.getElementById("navMenuClose")!.addEventListener("click", close);
  document.getElementById("navMenuOpen")!.addEventListener("click", open);
};

/* RENDER */
// build nav menu list items and attach to <ul id="navigationMenuList">
const buildMenuItems = (items: INavMenuItem[]) => {
  const navMenuList = document.getElementById("navigationMenuList")!;
  items.forEach((item: INavMenuItem) => {
    let listItem: HTMLElement = document.createElement("li");
    listItem.appendChild(createMenuItem(item));
    navMenuList.appendChild(listItem);
  });
};

// create markup for menu item and add event
// e.g. <a id="main_content_link" href="#main_content">Videos</a>
const createMenuItem = (item: INavMenuItem) => {
  let link: HTMLElement = document.createElement("a");
  link.setAttribute("id", `${item.screenId}_link`);
  link.setAttribute("href", `#${item.screenId}`);
  let label = document.createTextNode(item.label);
  link.appendChild(label);

  link.addEventListener("click", (event) => {
    event.preventDefault();
    highlightSelectedItem(item.screenId);
    callback({ ACTION: NavMenuAction.itemClicked, state: item.screenId });
  });

  return link;
};

const close = (): void => {
  document
    .getElementById("navigationMenu")!
    .classList.add("menu-screen--closed");
  document.getElementById("navMenuClose")!.classList.add("close-button--hide");
  document
    .getElementById("navMenuOpen")!
    .classList.remove("hamburger-button--hide");
  isMenuOpen = false;
  callback({ ACTION: NavMenuAction.toggleMenu, state: isMenuOpen });
};

const open = (): void => {
  document
    .getElementById("navigationMenu")!
    .classList.remove("menu-screen--closed");
  document
    .getElementById("navMenuClose")!
    .classList.remove("close-button--hide");
  document
    .getElementById("navMenuOpen")!
    .classList.add("hamburger-button--hide");
  isMenuOpen = true;
  callback({ ACTION: NavMenuAction.toggleMenu, state: isMenuOpen });
};

const init = (
  navMenuOptions: INavMenuItem[],
  navMenuCallback: Function
): void => {
  // forcing non-null assertion as navigationMenuCTA exists
  CTAButtonEl = document.getElementById("navigationMenuCTA")!;
  callback = navMenuCallback;
  addMenuButtonEvents();
  buildMenuItems(navMenuOptions);
  highlightSelectedItem(navMenuOptions[0].screenId);
  show();
};

const show = () => {
  CTAButtonEl.className = "navigation-menu";
};

const setTheme = (theme: string) => {
  CTAButtonEl.className = `navigation-menu navigation-menu--${theme}-theme`;
};

const highlightSelectedItem = (id: string) => {
  // remove highlight from previous selected menu item
  if (gCurrentSelected) {
    gCurrentSelected.classList.remove("menu-screen__item--selected");
  }
  // update new selected item and add highlight
  gCurrentSelected = document.getElementById(`${id}_link`)!;
  gCurrentSelected.classList.add("menu-screen__item--selected");
};

export { close, init, setTheme, INavMenuItem, INavMenuCallback, NavMenuAction };
